/**
 * BAMBOOVE — HIEU UNG DUNG CHUNG: HIEN DAN + DEM SO  (12/10/2026 · phieu 54)
 * ---------------------------------------------------------------------------
 * VI SAO CO FILE NAY
 *   Truoc day moi khoi tu viet lay 1 ban `data-bb-fade` (lap o 7 file). File nay la
 *   BAN DUNG CHUNG: khoi moi chi can `{%- render 'bamboove-reveal' -%}` la co hieu ung.
 *
 * CACH DUNG
 *   - Hien dan : them thuoc tinh `data-bb-fade` vao phan tu can hien dan.
 *                CSS cua khoi do tu khai:  .xx__fade{opacity:0;transform:translateY(14px)}
 *                                           .xx__fade.is-in{opacity:1;transform:none}
 *   - Dem so   : them `data-bb-count` vao phan tu chua SO (vd "3x", "60%", "100+").
 *                Chu so GIU NGUYEN phan duoi (x / % / +) — chi chay phan so.
 *
 * AN TOAN
 *   - Ton trong "giam chuyen dong": hien ngay, khong dem (khong giat).
 *   - Khong co IntersectionObserver (trinh duyet cu) => hien ngay.
 *   - Chay lai khi Trinh soan theme nap khoi (`shopify:section:load`).
 *   - Nap nhieu lan trong 1 trang KHONG sao: the <script type="module"> cung URL
 *     chi duoc trinh duyet chay DUNG 1 LAN.
 */
(function () {
  'use strict';

  var LOP_HIEN = 'is-in';
  var NGUONG = 0.15;
  var LE_DUOI = '0px 0px -40px 0px';
  var THOI_GIAN_DEM = 900;

  var GIAM_CHUYEN_DONG =
    !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CO_IO = 'IntersectionObserver' in window;
  var daTheoDoi = typeof WeakSet === 'function' ? new WeakSet() : null;

  /** Dem tu 0 len so dich, giu nguyen phan duoi (x · % · +) */
  function demSo(el) {
    if (el.getAttribute('data-bb-count-xong')) return;
    el.setAttribute('data-bb-count-xong', '1');

    var goc = (el.textContent || '').trim();
    var khop = goc.match(/^([0-9][0-9.,]*)([\s\S]*)$/);
    if (!khop) return;

    var chuSo = khop[1];
    var duoi = khop[2] || '';
    var soDich = parseFloat(chuSo.replace(/,/g, ''));
    if (isNaN(soDich) || soDich <= 0) return;

    // "giam chuyen dong" => giu nguyen so cuoi, khong chay
    if (GIAM_CHUYEN_DONG || !window.requestAnimationFrame) return;

    var leThapPhan = (chuSo.split(/[.,]/)[1] || '').length;
    var moc = null;

    el.textContent = (0).toFixed(leThapPhan) + duoi;

    function buoc(t) {
      if (moc === null) moc = t;
      var p = Math.min((t - moc) / THOI_GIAN_DEM, 1);
      var gia = soDich * (1 - Math.pow(1 - p, 3)); // cham dan o cuoi
      el.textContent = gia.toFixed(leThapPhan) + duoi;
      if (p < 1) {
        window.requestAnimationFrame(buoc);
      } else {
        el.textContent = goc; // tra ve DUNG chu goc (an toan ca khi co dinh dang la)
      }
    }

    window.requestAnimationFrame(buoc);
  }

  /** 1 phan tu vua vao khung nhin: hien + bat dau dem so ben trong */
  function kichHoat(el) {
    el.classList.add(LOP_HIEN);

    var con = el.querySelectorAll('[data-bb-count]');
    for (var i = 0; i < con.length; i++) demSo(con[i]);
    if (el.hasAttribute('data-bb-count')) demSo(el);
  }

  function theoDoi(ds) {
    if (!ds.length) return;

    if (!CO_IO || GIAM_CHUYEN_DONG) {
      for (var i = 0; i < ds.length; i++) kichHoat(ds[i]);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (!entries[k].isIntersecting) continue;
          kichHoat(entries[k].target);
          io.unobserve(entries[k].target);
        }
      },
      { threshold: NGUONG, rootMargin: LE_DUOI }
    );

    for (var j = 0; j < ds.length; j++) {
      var el = ds[j];
      if (daTheoDoi) {
        if (daTheoDoi.has(el)) continue;
        daTheoDoi.add(el);
      }
      io.observe(el);
    }
  }

  function chay(root) {
    var pham = root || document;
    if (!pham.querySelectorAll) return;
    theoDoi(pham.querySelectorAll('[data-bb-fade], [data-bb-count]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      chay(document);
    });
  } else {
    chay(document);
  }

  // Trinh soan theme: khoi nao nap lai thi chay lai cho khoi do
  document.addEventListener('shopify:section:load', function (e) {
    chay(e.target);
  });
})();
